import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Icon,
  Text,
  Thead,
  Tbody,
  useDisclosure,
  Table,
  Spinner,
} from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai'
import { Button } from '../../../../../../components/Button'
import { api } from '../../../../../../services/api'
import { useQuery } from 'react-query'
import { Columns } from './Columns'
import { List } from './List'
import { format } from 'date-fns'
import { formatPrice } from '../../../../../../utils/formatPrice'

async function getInfoHistoricoProposta({ numeroNota }) {
  const response = await api.get(`/site/v2/orcamento-crm/listar-dados-historico/${numeroNota}`)

  const formattedData = response.data.map((item) => {
    return {
      ...item,
      data_envio: item.data_envio ? format(new Date(item.data_envio), 'dd/MM/yyyy HH:mm') : '',
      valor_proposta: formatPrice(item.valor_proposta),
      original_valor_proposta: item.valor_proposta,
    }
  })

  formattedData?.sort((a, b) => {
    return new Date(b.original_data_abertura) - new Date(a.original_data_abertura)
  })

  return formattedData
}

export function HistoricoProposta({ infoProposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()

  const { data: historicoProposta = [], isLoading } = useQuery({
    queryKey: 'historicoProposta',
    queryFn: () =>
      getInfoHistoricoProposta({
        numeroNota: infoProposta?.num_proposta,
      }),
    refetchOnWindowFocus: false,
    enabled: isOpen,
  })

  // const totalValue = useMemo(() => {
  //   return historicoProposta.reduce((acc, item) => {
  //     return acc + Number(item.original_valor_proposta);
  //   }, 0);
  // }, [historicoProposta]);

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" cursor="pointer" onClick={onOpen} pointerEvents={'auto'}>
        <Text>
          Histórico Proposta: <strong>{infoProposta?.total_proposta}</strong>{' '}
        </Text>
        <Icon as={AiFillPlusCircle} color="#378BBF" fontSize="20px" />
      </Flex>
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase">
            Histórico Proposta: <strong>{infoProposta?.total_proposta}</strong>
          </DrawerHeader>

          <DrawerBody>
            <Table mt={4} borderCollapse="collapse" variant="outline">
              <Thead>
                <Columns />
              </Thead>
              <Tbody>
                {isLoading && (
                  <Flex
                    position="fixed"
                    zIndex="9999"
                    //transparente, com blur e no centro da tela
                    bg="rgba(255, 255, 255, 0.5)"
                    w="100%"
                    h="100%"
                    justifyContent="center"
                    alignItems="center"
                    backdropFilter="blur(5px)"
                    flexDirection="column"
                    gap={2}
                  >
                    <Text fontSize="20px" color="blue.500" fontWeight="bold" textAlign="center">
                      Carregando informações de pedidos...
                    </Text>
                    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
                  </Flex>
                )}
                <List data={historicoProposta} />
              </Tbody>
            </Table>
          </DrawerBody>

          <DrawerFooter position="sticky" mt="auto" bottom="0" boxShadow="0px 3px 6px rgba(0, 0, 0, 0.635)">
            <Flex alignItems="center" justifyContent="end" w="100%">
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                bgColor="transparent"
                color="#FFA200"
                border="1px solid #FFA200"
                onClick={onClose}
              >
                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                Voltar
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
